"use strict";
// /** This is a list of all features, that are not included
//  * in the base version of Autoboard and are booked by choosing a higher tier.
//  * 
//  * This enum will be used:
//  *  Server: To prevent unauthorized API requests.
//  *  App: To hide UI-elements, that are associated with a `BookableFeature`
//  */
// export enum EBookableFeatures {
//   VEHICLE_DOCUMENT_UPLOAD = 'V_DUP',
//   VEHICLE_ARCHIVE = 'V_ARC',
//   VEHICLE_PRINTABLE_DOCUMENTS = 'V_PDO',
//   VEHICLE_EXPORT = 'V_EXP',
//   API_ONLINE_PLATFORMS = 'API_OP',
//   API_SCHWACKE = 'API_SCH',
//   API_LINK_ENTRY = 'API_LIN',
//   API_WEBSITE_INTEGRATION = 'API_WIN',
//   /** If a tenant can use any workflows functionality. */
//   WORKFLOWS_MAIN = 'W_MAI',
//   WORKFLOWS_TEMPLATES = 'W_TEM',
//   WORKFLOWS_MANUAL_TASK = 'W_MTA',
//   WORKFLWOS_MANUAL_RULE = 'W_MRU',
//   /** If a tenant can use any survey functionality. */
//   SURVEY_MAIN = 'S_MAI',
//   /** If a tenant can use fuel functionality. */
//   FUEL_MAIN = 'F_MAIN',
//   EXTERNAL_USER_ACCESS = 'U_EXU',
// };
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFeatures = void 0;
/** Defines names for functionality in Autoboard.
 * Will be used to define transaction costs associated with each usage or
 * it will be used to disable or enable a function for a tenant. */
var EFeatures;
(function (EFeatures) {
    EFeatures["VEHICLE_RESERVATION"] = "V_RESERVE";
    EFeatures["VEHICLE_REMOVE_RESERVATION"] = "V_DEL_RESERVE";
    EFeatures["VEHICLE_SALE"] = "V_SALE";
    EFeatures["VEHICLE_REMOVE_SALE"] = "V_DEL_SALE";
    EFeatures["VEHICLE_ADD"] = "V_ADD";
    EFeatures["VEHICLE_UPDATE"] = "V_UPD";
    EFeatures["VEHICLE_DELETE"] = "V_DEL";
    EFeatures["VEHICLE_REACTIVATE"] = "V_REACTIVATE";
    EFeatures["VEHICLE_HANDOVER"] = "V_HAND";
    EFeatures["VEHICLE_EXPORT"] = "V_EXP";
    EFeatures["API_DAT_VIN"] = "API_DAT_VIN";
    EFeatures["API_SCHWACKE_PREIMPORT"] = "API_SCHWACKE_PRE";
    EFeatures["API_SCHWACKE_VIN"] = "API_SCHWACKE_VIN";
    EFeatures["API_LINK_ENTRY_IMPORT"] = "API_LINK_IMP";
    EFeatures["API_LINK_ENTRY_IMAGE"] = "API_LINK_IMG";
    EFeatures["API_SPOTICAR_EXPORT"] = "API_SPOTICAR_EXP";
    EFeatures["API_SPOTICAR_UPDATE"] = "API_SPOTICAR_UPD";
    EFeatures["API_MOBILE_EXPORT"] = "API_MOBILE_EXP";
    EFeatures["API_MOBILE_UPDATE"] = "API_MOBILE_UPD";
    EFeatures["API_ONLINE_EXPORT"] = "API_ONLINE_EXP";
    EFeatures["API_JUHU_AUTO"] = "API_JUHU_AUTO";
    EFeatures["API_LOCO_PREIMPORT"] = "API_LOCO_PRE";
    EFeatures["API_LOCO_IMPORT"] = "API_LOCO_IMP";
    EFeatures["API_US_VIN"] = "API_US_VIN";
    EFeatures["USER_ADD"] = "U_ADD";
    EFeatures["USER_UPDATE"] = "U_UPD";
    EFeatures["USER_DELETE"] = "U_DEL";
    EFeatures["USER_EXTERNAL_ACCESS"] = "U_EXT";
    EFeatures["FILE_ADD"] = "F_ADD";
    EFeatures["FILE_GET"] = "F_GET";
    EFeatures["FILE_DELETE"] = "F_DEL";
    EFeatures["COMMENT_ADD"] = "C_ADD";
    EFeatures["COMMENT_DELETE"] = "C_DEL";
    EFeatures["WORKFLOW_ADD"] = "W_ADD";
    EFeatures["WORKFLOW_UPDATE"] = "W_UPD";
    EFeatures["WORKFLOW_DEL"] = "W_DEL";
    EFeatures["WORKFLOW_TRIGGER_EVENT"] = "W_EVENT";
    EFeatures["WORKFLOW_TRIGGER_TASK"] = "W_TASK";
    EFeatures["PRINT_DATASHEET"] = "P_DATA";
    EFeatures["PRINT_PRICING"] = "P_PRICE";
    EFeatures["PRINT_TEMPLATE"] = "P_TEMPLATE";
    EFeatures["SUPPORT_TICKET"] = "SUPPORT_TICKET";
    EFeatures["SURVEY_ADD"] = "SURV_ADD";
    EFeatures["SURVEY_RESPONSE"] = "SURV_RESP";
    EFeatures["SURVEY_DELETE"] = "SURV_DEL";
    EFeatures["FUEL_MAIN"] = "FUEL";
    EFeatures["OFFER_AI_RECOGNITION"] = "OFFER_AI_RECOGNITION";
    EFeatures["OFFER"] = "OFFER";
    EFeatures["OPPORTUNITY"] = "OPPORTUNITY";
})(EFeatures = exports.EFeatures || (exports.EFeatures = {}));
